module.exports = __webpack_public_path__ + "static/media/bg-sidebar.6fe4a92b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-sidebar.jpg
// module id = 362
// module chunks = 33